import { getQuote } from "~/api";

const state = {
  id: null,
  record: null
};

const getters = {
  id: state => state.id,
  record: state => state.record
};

const actions = {
  setId({ commit }, id) {
    commit("SET_ID", id);
  },

  setRecord({ commit }, record) {
    commit("SET_RECORD", record);
  },

  fetchRecord({ commit, state }) {
    return new Promise((resolve, reject) => {
      getQuote(state.id)
        .then(response => {
          commit("SET_RECORD", response);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

const mutations = {
  ["SET_ID"](state, id) {
    state.id = id;
  },

  ["SET_RECORD"](state, record) {
    state.record = record;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
